module.exports = __webpack_public_path__ + "img/_DSC4889.cd08f810.webp";